<template>
  <div class="page">
    <div id="page-header" class="page-header">
      <h2 class="page-header__title">受講了解事項</h2>
    </div>
    <div id="page-content" class="page-content">
      <article>
        <section>
          <div class="page-content__article-section-body--indent">
            <p>
              スノーケリング、スキンダイビング、スクーバダイビングは、大いなる海の世界をあなたにひらいてくれる素晴らしいスポーツです。しかし一方、特殊な器材を使用し、特殊な環境下で行うものだけに、さまざまな知識の習得とトレーニングが必要です。この受講了解事項はトレーニングを受ける上で、理解しておかなければならない事項が記載されています。よく読んで了承の上、署名してください。
            </p>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">【健康について】</h4>
          <div class="page-content__article-section-body--indent">
            <p>
              スノーケリング、スキンダイビング、スクーバダイビングは、時に激しい動きをしなければならないスポーツです。循環器や呼吸器が正常であること、特にスクーバダイビングは、耳や副鼻腔内の圧平衡がとれることが条件とされています。メディカルチェックは正確に記入し、場合によっては医師による診断書を提出していただくことがあります。
            </p>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">【用具について】</h4>
          <div class="page-content__article-section-body--indent">
            <p>
              安全という意味からも、身に触れる用具は個人用として購入する必要があります。インストラクターの指導のもとに、購入することをお勧めします。また、レンタルできる用具の中にも、受講料に含まれているものと別料金が必要なものがありますので、事前にインストラクターに確認してください。
            </p>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">【出席、受講期限について】</h4>
          <div class="page-content__article-section-body--indent">
            <p>
              定められた学科及び実技講習のすべてに出席しなければなりません。また各コース規準に定められた講習内容を修了しない場合は認定を受けることができません。
            </p>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">【認定カード申請について】</h4>
          <div class="page-content__article-section-body--indent">
            <p>
              すべての講習終了後、認定カード(Cカード)の申請をしていただきます。認定カード申請は講習終了後2週間以内にダイブセンターもしくはインストラクターの下、行って頂きます。2週間を経過しても申請手続きがなされない場合、認定資格を放棄したものとみなします。
            </p>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">【海洋実習について】</h4>
          <div class="page-content__article-section-body--indent">
            <p>
              トレーニングには海洋実習が必須項目であり、学科講習及びプール実習後できるだけ速やかに受講することが大切です。海洋実習は自然を相手に行うものですから、潜在的なリスクを伴っていることを十分に理解して下さい。また安全確保のために、インストラクターの指示に従い慎重に行動して下さい。
            </p>
          </div>
        </section>
        <section>
          <div class="page-content__article-section-body--indent">
            <p>
              上記の内容について理解し了承しました。受講中はインストラクターの指示に従い、学科、実技講習とも必要とされるレベル習得に向けて最大限の努力を行います。インストラクターの指示に従わない場合や、出席、金銭支払い等の義務を怠った時は、受講を取り消されることを了承しています。
            </p>
          </div>
        </section>
        <section>
          <h4 class="page-content__article-section-title">「お客様の個人情報の取得に関して」</h4>
          <div class="page-content__article-section-body--indent">
            <p>
              お客様の個人情報は以下の目的でのみ利用させて頂く場合がございます。
              <ol>
                <li>
                  各ダイビングコース、ダイビング実習、各種イベントの案内及び役務・サービス提供のため
                </li>
                <li>
                  ダイビング器材の販売、もしくはご紹介とご案内のため
                </li>
              </ol>
            </p>
          </div>
        </section>
      </article>
    </div>
    <div id="page-footer" class="page-footer">
      <div class="page-footer__next-button-wrapper">
        <div class="page-footer__next-button-inner">
          <router-link to="/application-form" custom v-slot="{ navigate }">
            <button id="nextButton" class="btn btn-secondary rounded-pill" @click="navigate">
              前ページに戻る
            </button>
          </router-link>
        </div>
        <div class="page-footer__next-button-inner">
          <router-link to="/medical-check" custom v-slot="{ navigate }">
            <button id="nextButton" class="btn btn-danger rounded-pill" @click="navigate">
              健康チェック画面へ進む
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
@import 'stylesheets/page.scss';
</style>
